// extracted by mini-css-extract-plugin
export default {"action-button":"delete-user_action-button__XfTIA"};